import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { CashPayment } from '../../../Models/Models/PortfolioAnalysis/Payment/CashPayment';
import { CashPaymentTypeQuery } from '../../../Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery';
import { CashPaymentFrequencyQuery } from '../../../Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class CashPaymentClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, type: CashPaymentTypeQuery, frequency: CashPaymentFrequencyQuery): Promise<Array<CashPayment>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Payment/CashPayment/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, type: type, frequency: frequency }

    return AjaxWrapper.get<Array<CashPayment>, any>(url, data);
  }
}

